import {css} from '@yandex-delivery/blocks/theme/css'

export const modal = css`
  inline-size: 480px;
`
